import React, { useState } from 'react';

// Documentacao do fluxo de atendimento WhatsApp + chamados.
// Compartilhada entre as paginas /ti/atendimentos e /ti/chamados:
// alterar o conteudo aqui reflete automaticamente nos dois lugares.
const FLUXO_DOC = [
  {
    titulo: '1. Cliente abre um atendimento',
    icone: 'bi-1-circle',
    texto: [
      'O cliente envia uma mensagem no WhatsApp do canal ativo.',
      'Se nao existe conversa, ou a anterior foi encerrada, o bot conduz o intake conversacional dentro do proprio WhatsApp:',
      '* *Nome* completo (sugere o push name do WhatsApp).',
      '* *Filial* - bot lista as filiais cadastradas com o codigo do ERP (ex: *01* - ESPERA FELIZ). Cliente responde com o codigo (1 ou 01 funcionam) ou o nome.',
      '* *Setor* - se houver setores cadastrados em /admin/atendimento, bot lista numerado; senao aceita texto livre.',
      '* *Categoria* - lista as categorias administradas.',
      '* *Titulo* curto + *Descricao* livre.',
      'Bot mostra um resumo e pede confirmacao (*sim* / *cancelar*). Confirmando, o chamado nasce em siti_chamados, vinculado ao contato_id da conversa, e o bot responde no WhatsApp com *#N* (numero do protocolo). A conversa fica em status ABERTA com chamado_id preenchido.',
    ],
  },
  {
    titulo: '2. Cliente volta a mandar mensagem',
    icone: 'bi-2-circle',
    texto: [
      'O bot oferece um menu de retorno em DUAS situacoes:',
      '(a) conversa ABERTA com chamado vinculado, mas nenhum atendente assumiu ainda;',
      '(b) conversa ENCERRADA pelo atendente e o contato volta com nova mensagem.',
      'As 5 opcoes do menu:',
      '*1* - Abrir um novo atendimento (reusa nome/filial/setor; comeca direto na categoria).',
      '*2* - Consultar/atualizar atendimentos em aberto - lista os chamados ativos. Cliente escolhe um e depois decide se quer *adicionar informacoes*, *encerrar como resolvido* ou *cancelar*.',
      '*3* - Consultar atendimentos anteriores - mostra os 10 ultimos resolvidos/fechados/cancelados; digite o numero para ver detalhes (status, datas, descricao). Comando *mais* pagina os proximos 10. Comando *menu* volta ao menu.',
      '*4* - Cancelar um atendimento em aberto - atalho para listar abertos e cancelar.',
      '*5* - Sair (encerrar este menu) - se ha chamado vinculado, a conversa fica aberta com o bot silenciado para o atendente continuar. Se nao ha chamado vinculado, a conversa e encerrada para nao ficar pendurada na bandeja.',
      'O bot para de oferecer o menu e fica em silencio quando: (i) o atendente clica em "Assumir" ou envia a primeira mensagem manual; (ii) o cliente escolhe a opcao 5 (ou digita *cancelar*); (iii) o cliente escolheu "adicionar informacoes". A partir dai mensagens vao direto pro atendente.',
      'Comandos globais: *cancelar* (mesma acao da opcao 5), *novo* forca abrir novo chamado, *menu* volta ao topo do retorno.',
    ],
  },
  {
    titulo: '3. Atendente assume e foca em um chamado',
    icone: 'bi-3-circle',
    texto: [
      'No header da conversa, chips mostram os chamados em aberto do contato. Clicar em um chip define o *chamado em foco*.',
      'Quando o atendente clica em "Assumir" (ou envia a primeira mensagem manual), o bot avisa o cliente automaticamente: "Ola! [Nome do atendente] assumiu o seu atendimento e vai te ajudar agora." A partir desse momento o bot fica em silencio.',
      'Mensagens enviadas pelo atendente com chamado em foco ficam vinculadas a esse chamado (siti_mensagem.chamado_id) - a conversa do WhatsApp vira parte do historico do chamado.',
      'Anexos via clipe ao lado do compose: imagem, audio, video e documento ate 25MB. O arquivo sobe pro Supabase Storage e e enviado pela Evolution junto com a mensagem (legenda opcional). O cliente pode tambem colar imagens com Ctrl+V no campo de texto.',
      'Quando o cliente escolhe "adicionar informacoes" pelo menu de retorno, as proximas mensagens dele ficam vinculadas ao chamado escolhido, e a acao fica registrada em siti_atendimento_acao_chamado para indicadores.',
    ],
  },
  {
    titulo: '4. Encerramento',
    icone: 'bi-4-circle',
    texto: [
      'A conversa nunca encerra sozinha - o atendente decide via botao "Encerrar".',
      'Duas opcoes (um chamado por vez):',
      '* Encerrar *somente a conversa* - chamados vinculados continuam em aberto, sem motivo.',
      '* Encerrar a *conversa + chamado em foco* (resolvido) - exige selecionar um motivo do catalogo. O motivo vai pra siti_chamados.motivo_fechamento e tambem entra como comentario do chamado.',
      'Em qualquer modo, o bot envia ao cliente uma mensagem automatica de encerramento. Quando um chamado e resolvido junto, a mensagem cita o numero (#N) marcado como resolvido.',
      'Para encerrar mais de um chamado da mesma pessoa, o atendente troca o chip em foco e clica Encerrar novamente.',
      'Se a conversa ja foi encerrada e ainda tem chamados em aberto vinculados, o botao vira "Resolver chamado" e mostra apenas a opcao com motivo.',
      'Quando uma conversa encerrada recebe nova mensagem do cliente, o ciclo recomeca pelo passo 2.',
      'Em /ti/chamados ha um botao *Historico* por linha (apenas para chamados originados do WhatsApp): abre uma modal com a thread do chamado em formato chat (mensagens vinculadas ao chamado + intake e notificacoes do bot daquela sessao).',
    ],
  },
  {
    titulo: 'Configuracao em /admin/atendimento',
    icone: 'bi-gear',
    texto: [
      '*Horario de atendimento* - uma linha por dia da semana com janela em HH:mm. Fora do horario o bot envia mensagem customizada e nao inicia intake. Conversas ja em andamento continuam normalmente.',
      '*Mensagens automaticas* - saudacao, fora de horario, cancelamento e pos-chamado-criado (com placeholder {{numero}}). Em branco, o bot usa o texto padrao.',
      '*Motivos de encerramento* - lista cadastravel exibida no select do encerrar. Inativos somem da lista, mas chamados ja fechados mantem o registro do motivo.',
      '*Categorias* - catalogo administravel. Inativas somem da lista mostrada ao cliente no intake.',
      '*Filiais* - sincronizadas com BDENTER..FILIALCAD via botao "Importar do ERP". O catalogo guarda o codigo (ex: 01, 03) que o cliente informa no WhatsApp. A importacao preenche o codigo das ja existentes (match por nome), insere as faltantes e renomeia onde o ERP renomeou.',
      '*Setores* - catalogo administravel. Vazio = bot aceita texto livre.',
      '*SLA por prioridade* (TTFR e TTR em minutos) - hoje so referencia visual; serao usados em metricas e alertas nas proximas fases.',
    ],
  },
];

// Fluxograma SVG. Coordenadas em pixels dentro do viewBox 430x920.
function FluxogramaSVG() {
  const corProc = '#2A8A9C';
  const corProcBg = 'rgba(42, 138, 156, 0.18)';
  const corDec = '#fe8d25';
  const corDecBg = 'rgba(254, 141, 37, 0.18)';
  const corLinha = 'rgba(255,255,255,0.45)';
  const corTxt = '#fff';

  const Box = ({ x, y, w, h, label, fill, stroke }) => (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={10} ry={10} fill={fill} stroke={stroke} strokeWidth={1.5} />
      {label.split('\n').map((linha, i) => (
        <text
          key={i}
          x={x + w / 2}
          y={y + h / 2 + (i - (label.split('\n').length - 1) / 2) * 16}
          textAnchor="middle"
          dominantBaseline="middle"
          fill={corTxt}
          fontSize="13"
          fontWeight="600"
        >
          {linha}
        </text>
      ))}
    </g>
  );

  const Diamond = ({ cx, cy, w, h, label }) => (
    <g>
      <polygon
        points={`${cx},${cy - h / 2} ${cx + w / 2},${cy} ${cx},${cy + h / 2} ${cx - w / 2},${cy}`}
        fill={corDecBg}
        stroke={corDec}
        strokeWidth={1.5}
      />
      {label.split('\n').map((linha, i) => (
        <text
          key={i}
          x={cx}
          y={cy + (i - (label.split('\n').length - 1) / 2) * 14}
          textAnchor="middle"
          dominantBaseline="middle"
          fill={corTxt}
          fontSize="12"
          fontWeight="600"
        >
          {linha}
        </text>
      ))}
    </g>
  );

  return (
    <svg
      viewBox="0 0 430 920"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMin meet"
    >
      <defs>
        <marker id="seta" viewBox="0 0 10 10" refX="9" refY="5"
          markerWidth="6" markerHeight="6" orient="auto-start-reverse">
          <path d="M 0 0 L 10 5 L 0 10 z" fill={corLinha} />
        </marker>
      </defs>

      <Box x={100} y={10} w={160} h={42} label={'Cliente envia mensagem'} fill={corProcBg} stroke={corProc} />
      <line x1={180} y1={52} x2={180} y2={80} stroke={corLinha} markerEnd="url(#seta)" />

      <Diamond cx={180} cy={108} w={210} h={64} label={'Conversa nova ou\nencerrada com\nretorno?'} />

      <text x={70} y={155} fontSize="10" fill={corDec} fontWeight="700">nova</text>
      <path d={'M 130 130 Q 80 150 80 180'} fill="none" stroke={corLinha} markerEnd="url(#seta)" />

      <text x={250} y={155} fontSize="10" fill={corDec} fontWeight="700">retorno</text>
      <path d={'M 230 130 Q 285 150 285 180'} fill="none" stroke={corLinha} markerEnd="url(#seta)" />

      <Box x={20} y={185} w={120} h={56} label={'Bot inicia\nintake'} fill={corProcBg} stroke={corProc} />

      <Box x={195} y={185} w={160} h={92}
        label={'Menu de retorno\n1 novo | 2 abertos\n3 anteriores\n4 cancelar aberto'}
        fill={corProcBg} stroke={corProc} />

      <text x={170} y={285} fontSize="10" fill={corDec} fontWeight="700">1 - novo</text>
      <path d={'M 215 277 Q 195 320 165 360 L 95 360'} fill="none" stroke={corLinha} markerEnd="url(#seta)" />

      <text x={250} y={291} fontSize="10" fill={corDec} fontWeight="700">2 - em aberto</text>
      <line x1={260} y1={277} x2={260} y2={395} stroke={corLinha} markerEnd="url(#seta)" />

      <text x={345} y={232} fontSize="10" fill={corDec} fontWeight="700">3</text>
      <path d={'M 355 230 L 380 230 L 380 280'} fill="none" stroke="none" />
      <path d={'M 355 220 L 380 220 L 380 270'} fill="none" stroke={corLinha} markerEnd="url(#seta)" />
      <Box x={300} y={272} w={120} h={64}
        label={'Consulta\nanteriores\n(pagina/detalha)'}
        fill={corProcBg} stroke={corProc} />
      <path d={'M 360 272 Q 380 200 355 195'} fill="none" stroke={corLinha}
        strokeDasharray="4 3" markerEnd="url(#seta)" />

      <Box x={170} y={395} w={190} h={56} label={'Cliente escolhe acao:\ninfo | resolver | cancelar'}
        fill={corProcBg} stroke={corProc} />

      <line x1={80} y1={241} x2={80} y2={362} stroke={corLinha} markerEnd="url(#seta)" />
      <Box x={20} y={364} w={140} h={50} label={'Bot coleta\ncategoria, titulo,\ndescricao'} fill={corProcBg} stroke={corProc} />

      <line x1={90} y1={414} x2={90} y2={486} stroke={corLinha} markerEnd="url(#seta)" />
      <Box x={20} y={486} w={160} h={50} label={'Cliente confirma\n-> chamado #N criado'} fill={corProcBg} stroke={corProc} />

      <path d={'M 265 451 L 265 568'} fill="none" stroke={corLinha} markerEnd="url(#seta)" />
      <path d={'M 100 536 L 100 568'} fill="none" stroke={corLinha} markerEnd="url(#seta)" />

      <Box x={70} y={570} w={220} h={50} label={'Conversa fica ABERTA\ncom chamado vinculado'} fill={corProcBg} stroke={corProc} />
      <line x1={180} y1={620} x2={180} y2={650} stroke={corLinha} markerEnd="url(#seta)" />

      <Box x={70} y={650} w={220} h={56} label={'Atendente assume\ne foca em um chamado'} fill={corProcBg} stroke={corProc} />
      <line x1={180} y1={706} x2={180} y2={740} stroke={corLinha} markerEnd="url(#seta)" />

      <Box x={50} y={740} w={260} h={66} label={'Atendente encerra:\nso conversa | conv + chamado\nem foco'} fill={corDecBg} stroke={corDec} />

      <line x1={180} y1={806} x2={180} y2={840} stroke={corLinha} markerEnd="url(#seta)" />
      <Box x={130} y={840} w={100} h={40} label={'Atendimento\nfinalizado'} fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.4)" />

      <g transform="translate(10,895)">
        <rect width={16} height={16} fill={corProcBg} stroke={corProc} strokeWidth="1" />
        <text x={24} y={13} fontSize="12" fill={corTxt}>Processo</text>
        <polygon points="100,2 114,9 100,16 86,9" fill={corDecBg} stroke={corDec} strokeWidth="1" />
        <text x={120} y={13} fontSize="12" fill={corTxt}>Decisao</text>
      </g>
    </svg>
  );
}

function FluxoModal({ aberto, onClose }) {
  if (!aberto) return null;
  return (
    <div
      className="modal d-block"
      style={{ background: 'rgba(0,0,0,0.7)' }}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      >
        <div className="modal-content" style={{ background: 'var(--portal-surface)', color: 'var(--portal-text)' }}>
          <div className="modal-header" style={{ borderColor: 'var(--portal-border)' }}>
            <h5 className="modal-title">
              <i className="bi bi-info-circle me-2" />
              Como funciona o atendimento WhatsApp
            </h5>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body" style={{ maxHeight: '78vh', overflowY: 'auto' }}>
            <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)' }}>
              Este e o fluxo proposto para conversas e chamados andarem lado a lado.
              Use como referencia rapida ao operar a tela.
            </p>

            <div className="row g-3">
              <div className="col-12 col-lg-6">
                {FLUXO_DOC.map((bloco, idx) => (
                  <div
                    key={idx}
                    style={{
                      marginBottom: 14,
                      padding: 12,
                      borderRadius: 10,
                      border: '1px solid var(--portal-border)',
                      background: 'rgba(42, 138, 156, 0.06)',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                      <i className={`bi ${bloco.icone}`} style={{ fontSize: '1.3rem', color: '#2A8A9C' }} />
                      <strong style={{ fontSize: '0.92rem' }}>{bloco.titulo}</strong>
                    </div>
                    <ul style={{ paddingLeft: 20, marginBottom: 0, fontSize: '0.82rem', lineHeight: 1.5 }}>
                      {bloco.texto.map((linha, li) => (
                        <li key={li} style={{ marginBottom: 3 }}>{linha}</li>
                      ))}
                    </ul>
                  </div>
                ))}

                <div
                  style={{
                    padding: 10,
                    borderRadius: 8,
                    background: 'rgba(76, 181, 83, 0.12)',
                    border: '1px solid rgba(76, 181, 83, 0.4)',
                    fontSize: '0.78rem',
                    color: 'var(--portal-text)',
                  }}
                >
                  <strong><i className="bi bi-check-circle me-1" /> Fluxo completo ativo.</strong>
                  {' '}
                  Tanto o lado do cliente (passo 2) quanto o lado do atendente
                  (passos 3 e 4) estao implementados.
                </div>
              </div>

              <div className="col-12 col-lg-6">
                <div
                  style={{
                    padding: 12,
                    borderRadius: 10,
                    border: '1px solid var(--portal-border)',
                    background: 'rgba(0,0,0,0.18)',
                  }}
                >
                  <div style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 8, textAlign: 'center' }}>
                    Fluxograma
                  </div>
                  <FluxogramaSVG />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer" style={{ borderColor: 'var(--portal-border)' }}>
            <button className="btn btn-outline-secondary" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Botao "i" + modal autocontido. Renderize ao lado do titulo da pagina:
//   <h1>Atendimentos</h1>
//   <InfoFluxoAtendimento />
// Editar o conteudo aqui (FLUXO_DOC / FluxogramaSVG / FluxoModal) reflete
// automaticamente em /ti/atendimentos e /ti/chamados.
export default function InfoFluxoAtendimento() {
  const [aberto, setAberto] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        title="Como funciona o atendimento"
        aria-label="Como funciona o atendimento"
        style={{
          background: 'transparent',
          border: '1px solid var(--portal-border)',
          color: '#2A8A9C',
          width: 30,
          height: 30,
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1rem',
        }}
      >
        <i className="bi bi-info-lg" />
      </button>
      <FluxoModal aberto={aberto} onClose={() => setAberto(false)} />
    </>
  );
}
